export default __webpack_public_path__ + "static/media/clubracers-header.a99ee2b8.jpg";